<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-title>Pacotes de {{ athleteName }}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="close()" aria-label="Fechar">
        <ion-icon slot="icon-only" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="pkg-picker">
  @if (packageList().length === 0) {
    <div class="pkg-picker__empty">
      <ion-icon name="ticket-outline" aria-hidden="true"></ion-icon>
      <p class="pkg-picker__empty-title">Nenhum pacote disponível</p>
      <p class="pkg-picker__empty-hint">
        Este cliente não tem pacote com cupom livre neste centro esportivo.
      </p>
    </div>
  } @else {
    <p class="pkg-picker__intro">Escolha o pacote e depois o cupom que vai pagar este horário.</p>

    @if (selectedCouponId) {
      <button type="button" class="pkg-picker__clear" (click)="clearSelection()">
        <ion-icon name="close-circle-outline" aria-hidden="true"></ion-icon>
        Não usar cupom nesta reserva
      </button>
    }

    @for (pack of packageList(); track pack.rentPackageId) {
      <div class="pkg-item" [class.pkg-item--open]="openedRentPackageId() === pack.rentPackageId">
        <button type="button" class="pkg-item__head" (click)="openPackage(pack)">
          <div class="pkg-item__info">
            <span class="pkg-item__name">{{ pack.packageName }}</span>
            <span class="pkg-item__meta">
              {{ packageSummary(pack) }}
              @if (validityLabel(pack.validityDate); as validity) {
                · vence {{ validity }}
              }
            </span>
          </div>
          <ion-icon
            class="pkg-item__chevron"
            [name]="openedRentPackageId() === pack.rentPackageId ? 'chevron-up' : 'chevron-down'"
            aria-hidden="true"></ion-icon>
        </button>

        @if (openedRentPackageId() === pack.rentPackageId) {
          <div class="pkg-item__coupons">
            @if (loadingCoupons()) {
              <div class="pkg-item__loading">
                <ion-spinner name="crescent"></ion-spinner>
                <span>Carregando cupons…</span>
              </div>
            } @else if (couponsError(); as err) {
              <p class="pkg-item__error">{{ err }}</p>
            } @else {
              @for (coupon of availableCoupons(); track coupon.couponId) {
                <button
                  type="button"
                  class="coupon-row"
                  [class.coupon-row--selected]="isSelected(coupon)"
                  (click)="chooseCoupon(coupon)">
                  <ion-icon
                    class="coupon-row__icon"
                    [name]="isSelected(coupon) ? 'checkmark-circle' : 'ticket-outline'"
                    aria-hidden="true"></ion-icon>
                  <div class="coupon-row__info">
                    <span class="coupon-row__id">Cupom #{{ coupon.couponId }}</span>
                    @if (validityLabel(coupon.validityDate); as validity) {
                      <span class="coupon-row__meta">vence {{ validity }}</span>
                    }
                  </div>
                  <span class="coupon-row__action">
                    {{ isSelected(coupon) ? 'Selecionado' : 'Usar' }}
                  </span>
                </button>
              }

              @if (availableCoupons().length === 0) {
                <p class="pkg-item__error">Nenhum cupom livre neste pacote.</p>
              }

              <!-- Usados e cancelados ficam visíveis, desabilitados: some-los faria
                   o "2 de 8 disponíveis" do topo parecer errado. -->
              @for (coupon of unavailableCoupons(); track coupon.couponId) {
                <div class="coupon-row coupon-row--disabled">
                  <ion-icon
                    class="coupon-row__icon"
                    name="ticket-outline"
                    aria-hidden="true"></ion-icon>
                  <div class="coupon-row__info">
                    <span class="coupon-row__id">Cupom #{{ coupon.couponId }}</span>
                    <span class="coupon-row__meta">{{ couponStatusLabel(coupon) }}</span>
                  </div>
                </div>
              }
            }
          </div>
        }
      </div>
    }
  }
</ion-content>
